import React, { Component }  from 'react'
import { Icon, Modal, Button } from 'semantic-ui-react'
import FileInput from '../../components/FileInput/FileInput'

class SectionSubjectsReadCSV extends Component {
  render() {
    return (
      <Modal
        trigger={
          <Button icon labelPosition='right' color='green'> <Icon name='upload' />
          Import Subjects
          </Button>
        }
        closeIcon
        >
        <Modal.Header>Import Subjects</Modal.Header>
        <Modal.Content>
            <FileInput
              handleFileChange={this.props.handleFileChange}
              id={this.props.sectionId}
              className='sections-file-input'
              error={false}
            />
        </Modal.Content>
        <Modal.Actions>
          <Button color='green' onClick={() => this.props.handleDataSaveSubjects(this.props.sectionId)}>
            <Icon name='checkmark' /> Save
          </Button>
        </Modal.Actions>
      </Modal>
    )
  }
};

export default SectionSubjectsReadCSV;
